import { getMetricValueAndContext } from '@core/utils/context-menu.utils'
import { MetricRequest } from '@core/models/metric.models'
import { Match } from '@core/models/match.models'
import { ContextMenuItemEvent } from '@core/models/context-menu.models'
import { parseMatchToMetricDetailRequest } from '@features/metric-detail/parsers/match-metric-detail.parser'

export const resolveMatchMetricDetailRequest = (payload: ContextMenuItemEvent): MetricRequest => {
  const { context, value } = getMetricValueAndContext<Match>(payload)

  return parseMatchToMetricDetailRequest(context, value)
}
